var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "4nvdu9lqma"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.725490 0 0 0 0 0.737255 0 0 0 0 0.745098 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#4nvdu9lqma)",
    transform: "translate(-14 -370) translate(-4)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0 20 20 0 20z",
    transform: "translate(18 370)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M15.847 11.072c.033-.248.05-.505.05-.778 0-.265-.017-.53-.058-.777L17.5 8.21c.148-.116.189-.34.099-.505l-1.573-2.746c-.098-.182-.303-.24-.483-.182l-1.957.794c-.41-.315-.844-.58-1.327-.778l-.295-2.1c-.032-.2-.196-.34-.393-.34H8.428c-.197 0-.352.14-.385.34l-.295 2.1c-.483.199-.925.472-1.327.778l-1.957-.794c-.18-.067-.385 0-.483.182L2.417 7.705c-.098.174-.066.389.098.505l1.662 1.307c-.04.248-.073.52-.073.777s.016.53.057.778L2.5 12.379c-.148.115-.189.339-.099.504l1.573 2.747c.098.182.303.24.483.182l1.957-.795c.41.315.844.58 1.327.778l.295 2.101c.04.199.196.34.393.34h3.144c.197 0 .36-.141.385-.34l.295-2.101c.483-.198.925-.463 1.327-.778l1.957.795c.18.066.385 0 .483-.182l1.572-2.747c.099-.182.058-.389-.098-.504l-1.646-1.307zM10 13.272c-1.621 0-2.948-1.34-2.948-2.978 0-1.638 1.327-2.978 2.948-2.978s2.948 1.34 2.948 2.978c0 1.638-1.327 2.978-2.948 2.978z",
    transform: "translate(18 370)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.4b32bf60aea5ed1ee873ace23e34a4b2.svg";
export { ForwardRef as ReactComponent };